import React from "react";
import PropTypes from "prop-types";

import { Graphics } from "./components/Graphics";

import "./style.scss";

export class BoxHolder extends React.Component {
  componentWillMount() {
    this.props.createBoxHolder({
      props: this.props.defaultProps,
    });
  }

  render() {
    return (
        <div
          id={"BoxHolder_"+this.props.id}
          className={'BoxHolder'}>
          <Graphics id={this.props.id} />
        </div>
    );
  }
}

BoxHolder.propTypes = {
  createBoxHolder: PropTypes.func,
};

BoxHolder.defaultProps = {};
